<script>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from '@/helpers/store-effect';
import ActionSettings from '@/components/workflows/settings/ActionSettings';
import AssignSettings from '@/components/workflows/settings/AssignSettings';
import ConditionSettings from '@/components/workflows/settings/ConditionSettings';
import ConditionBranchSettings from '@/components/workflows/settings/ConditionBranchSettings';
import TriggerSettings from '@/components/workflows/settings/TriggerSettings';
import OutputsViewer from '@/components/workflows/common/OutputsViewer';
import ErrorsViewer from '@/components/workflows/common/ErrorsViewer';
import ErrorWrapper from '@/components/workflows/common/ErrorWrapper';
import ParametersComposer from '@/components/workflows/common/ParametersComposer';
import { computed, provide } from 'vue';

export default {
  name: 'WorkflowNodeSettings',
  template: '#workflow-node-settings-template',
  props: {
    nodeUid: {
      type: String,
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const tab = computed(() => route.query.tab || 'settings');
    const node = props.workflow.get_node_by_uid(props.nodeUid);

    if (!node) {
      router.replace({
        name: 'editor',
        params: { uid: props.workflow.uid },
      });
      return {};
    }

    store.currentActiveNodes = [props.nodeUid];
    provide('node', node);

    return {
      node,
      tab,
    };
  },
  components: {
    ActionSettings,
    AssignSettings,
    ConditionSettings,
    ConditionBranchSettings,
    TriggerSettings,
    OutputsViewer,
    ErrorsViewer,
    ErrorWrapper,
    ParametersComposer,
  },
};
</script>

<style scoped>

</style>
